import api from "@/api";

export default {
  state: {
    secondSaleCategories: [],
    secondSaleCategoriesData: {},
    secondSaleCategoryTeamId: 0,
  },
  getters: {
    secondSaleCategories: (state) => state.secondSaleCategories,
    secondSaleCategoriesData: (state) => state.secondSaleCategoriesData,
    secondSaleCategoryTeamId: (state) => state.secondSaleCategoryTeamId,
  }, 
  mutations: {
    setSecondSaleCategories: (state, data) => {
      state.secondSaleCategories = data;
    },

    setSecondSaleCategoriesData: (state, data) => {
      state.secondSaleCategoriesData = data;
    },

    setSecondSaleCategoryTeamId: (state, data) => {
      state.secondSaleCategoryTeamId = data;
    },
  },
  actions: {

    deleteSecondSaleCategory: async (_, saleCategoryId) => {
      try {
        await api({ requiresAuth: true }).delete(
            `/v1/sales-categories/${saleCategoryId}`
        );
      } catch (err) {
        console.error(err);
      }
    },

    getSecondSaleCategories: async ({ commit }) => {
      try {
        const response = await api({ requiresAuth: true }).get(
          "/v1/sales-categories-second-agent"
        ); 
        const { data } = response;
        commit("setSecondSaleCategories", data);
      } catch (err) {
        console.error(err);
      }
    },

    getSecondSaleCategoriesByTeam: async ({ commit }, teamId) => {
      try {
        const { data } = await api({ requiresAuth: true }).get(
          `/v1/teams/${teamId}/sales-categories-second-agent`
        );
        commit("setSecondSaleCategories", data);
      } catch (err) {
        console.error(err);
      }
    },

    getSecondSaleCategoriesFormData: async ({ commit }) => {
      try {
        const {
          data: { data },
        } = await api({ requiresAuth: true }).get(
          "/v1/partials/sales-categories-forms"
        );
        commit("setSecondSaleCategoriesData", data);
      } catch (err) {
        console.error(err);
      }
    },

    addSecondSaleCategory: async ({ commit }, { title, provision, teamId }) => {
      try {
        await api({ requiresAuth: true }).post("/v1/sales-categories", {
          title,
          agent_provision: provision,
          team_id: teamId,
          is_secondary: true
        });
        commit("setToast", {
          display: true,
          type: "success",
          message: "Sale Category added successfully.",
        });
      } catch (err) {
        console.error(err);
      }
    },
  },
};
